import React from 'react';
import ReactDOM from 'react-dom/client';
import Button from './Components/Button/Button.js';
import Dropdown from './Components/Dropdown/Dropdown.js';
import Container from './Components/Layout/Container.js';
import Grid from './Components/Layout/Grid.js';
import Paragraph from './Components/Text/Paragraph.js';
import PasswordField from './Components/TextField/PasswordField.js';
import TextField from './Components/TextField/TextField.js';
import ThemeProvider from './Themes/ThemeProvider.js';
import Slider from "./Components/Sliders/Slider.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider applyBody theme="dark">
      <Container padding={4}>
        <Demo />
      </Container>
    </ThemeProvider>
  </React.StrictMode>
);

function Demo() {

  const longDropdownOptions = [];
  for (let i = 1; i < 100; i++) longDropdownOptions.push({ label: i, value: i });

  return (<>
    <Grid spacing={2}>
      <Container padding={2} style={{ border: "5px solid var(--yona-color-100)", borderRadius: 20 }}>
          <TextField placeholder="default" iconColor="DodgerBlue" icon="verified" id="test"/><br/>
          <TextField placeholder="underlined" iconColor="YellowGreen" icon="view_in_ar" variant="underlined"/><br/>
          <PasswordField placeholder="toggle peek"/><br/>
          <PasswordField placeholder="no peek" peek="none"/><br/>
          <PasswordField placeholder="hold to peek" peek="hold"/>
      </Container>
        <Container padding={2} style={{ border: "5px solid var(--yona-color-100)", borderRadius: 20 }}>
          <Grid direction="column">
            <Container>
              <Grid direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={2} padding={2}>
                <Button font="semibold">Button</Button>
                <Button font="bold">Button</Button>
                <Button font="shouting" background="glass">Button</Button>
              </Grid>
              <Grid direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={2} padding={2}>
                <Button shape="pill" color="slateblue" font="semibold">Button</Button>
                <Button shape="pill" color="slateblue" font="bold">Button</Button>
                <Button shape="pill" color="slateblue" font="shouting" background="glass">Button</Button>
              </Grid>
              <Grid direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={2} padding={2}>
                <Button size="large" color="orangered" font="semibold">Button</Button>
                <Button size="large" color="orangered" font="bold" disabled>Button</Button>
                <Button size="large" color="orangered" font="shouting" background="glass">Button</Button>
              </Grid>
              <Grid direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={2} padding={2}>
                <Button size="large" color="lightgreen" shape="pill" font="semibold">Button</Button>
                <Button size="large" color="lightgreen" shape="pill" font="bold">Button</Button>
                <Button size="large" color="lightgreen" shape="pill" font="shouting" background="glass">Button</Button>
              </Grid>
            </Container>
            <Container>
              <Paragraph weak>
                Buttons do exist in 2 sizes: <strong>32 px</strong> height and <strong>36px</strong> height,<br/>
                3 font styles: <strong>semibold</strong>, <strong>bold</strong> and <strong>Black (+Caps)</strong>,<br/>
                2 border styles: <strong>rounded</strong> and <strong>pill</strong> and<br/>
                2 background styles: <strong>full opacity</strong> and <strong>glass (main color 20% opacity)</strong>
              </Paragraph>
            </Container>
          </Grid>
        </Container>
        <Grid spacing={2}  direction="column" padding={2} style={{ border: "5px solid var(--yona-color-100)", borderRadius: 20 }}>
          Some text
          <Dropdown allowClear id="dropdown" placeholder="&quot;fancy&quot; animation" option="AAAAAAAAAA" options={[
            "plaintext",
            { label: "fancy object", value: "cool"},
            { value: "value only" },
            { label: "disabled", disabled: true },
            { label: "label only" },
          ]}/>
          <Dropdown/>
          <Dropdown options={longDropdownOptions} />
          <Dropdown size="large" chevronColors={{ arrow: "white"}} options={["single option"]}/>
          <Dropdown placeholder="Fixed width"  chevronColors={{ circle: "orangered"}} options={longDropdownOptions}/>
          <Dropdown placeholder="smol" size="small" chevronColors={{ circle: "yellowgreen", arrow: "yellowgreen"}} options={[
              "lorem ipsum dolor sit amet",
          ]}/>
        </Grid>
      <ThemeProvider theme="light">
        <Container padding={2} style={{ border: "5px solid var(--yona-color-100)", borderRadius: 20 }}>
            <Slider hideLabel sections={[ ".1", .5, ".2", .8]} round={5} value={1/3} /> This is a text
            <Slider sections={[ 1/3, 2/3, ]} maxValue={10} /> Without hidden label
            <Slider id="slider" type="knob" maxValue={10} /> This is some more text
        </Container>
      </ThemeProvider>
    </Grid>
  </>)
}